import React from "react";
import { useForm } from "react-hook-form";
import { DataContext } from "../../../../../state/DataContext/DataContext";
import { Job } from "../../../../../typings/Job";
import { useParams } from "react-router-dom";
import { JobForm } from "../JobForm";
import { SuccesToast } from "../../../../Shared/ToastMessage/SuccessToast";

export default function EditJob(props: { Job?: Job, onClose?: any, afterEditFn?: any, isEdit?: boolean }) {

    const [isLoading, setIsLoading] = React.useState(false);
    const [currentJob, setCurrentJob] = React.useState<Job>();
    const [fileArray, setFileArray] = React.useState([]);
    const [filesToBeDeleted, setFilesToBeDeleted] = React.useState([]);
    const [isSafeToRedirect, setIsSafeToRedirect] = React.useState(false);
    const { actions } = React.useContext(DataContext);
    let params = useParams<any>();

    const formControls = useForm({
        defaultValues: {} as Job,
    });
    const { setValue } = formControls;

    React.useEffect(() => {
        const job = props.Job;

        if (props.Job) {
            // Set initial form vallue
            setValue("CustomerName", job!.CustomerName)
            setValue("Title", job!.Title)
            setValue("Address", job!.Address)
            setValue("StartDateTime", job?.StartDateTime.toDate())
            setValue("EndDateTime", job?.EndDateTime.toDate())
            setValue("Note", job?.Note)
            setCurrentJob(job)

            // set files
            setFileArray(props?.Job.JobFiles)
        }
    }, [props.Job])


    const editJob = (values: Job, JobFiles: any) => {
        try {
            // Delete files in storage
            actions.Storage.Deletefile(filesToBeDeleted);

            // Delete job
            actions.Job.EditJob(
                { ...values, TenantID: params.tenantID, ID: props.Job.ID, JobFiles: JobFiles }
            );
            SuccesToast(values.Title)
            setIsLoading(false)
            props.afterEditFn()
        }
        catch (e) {
            console.log(e)
        }
    }

    const onSubmit = (values: any) => {
        setIsLoading(true)

        delete values.JobFiles;

        // EDIT
        if (fileArray.length > 0) {
            var promises = fileArray.map(file => {
                return actions.Storage.AddFileAndGetFileObject(file)
            })

            Promise.all(promises).then(function (JobFiles) {
                editJob(values, JobFiles)
            })
            if (props.onClose) { props.onClose() }
        }
        else {
            editJob(values, [])
            setIsLoading(false)
            if (props.onClose) { props.onClose() }

        }
    }

    return (
        <JobForm
            {...formControls}
            isEdit
            onSubmit={onSubmit}
            isLoading={isLoading}
            currentJob={currentJob}
            setFileArray={setFileArray}
            fileArray={fileArray}
            setFilesToBeDeleted={setFilesToBeDeleted}
            isSafeToRedirect={isSafeToRedirect}
            params
            errors={formControls.formState.errors}
        />
    );
}
